import { createAction } from '@reduxjs/toolkit';

export const similarProductsRequestComplete = createAction(
  'richRelevance/similarProductsRequestComplete',
);
